import React from 'react';
import {
  FDAvatar, FDBox,
  FDContentContainer, FDPaper, FDPrimaryActionButton,
  FDStack, FDTextButton,
} from '@facet-wealth/design';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import StepNavigationFooter from 'Packages/FacetDesign/Components/Experimental/StepNavigationFooter';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { dashboardWithModal } from 'Consts/clientUris';
import { navigateTo } from 'Helpers/Redirect';
import { clientPaths } from 'Consts/Strings';
import { useHistory } from 'react-router-dom';
import { LightPaper } from 'Views/Page/Content/Templates/TaxDiagnosticQuestionStepTemplate/LightPaper';
import { dataAttrs } from 'Helpers/Testing';
import { TaxYearOptionsDropdown } from 'Views/Page/Content/Templates/TaxDiagnosticCommon/TaxYearOptionsDropdown';

const Layout = () => {
  const history = useHistory();
  const { resource } = useMetaLayoutContext();
  const { loadPageContentLink } = usePageContentContext();

  useBoneBackgroundColor();

  const handleNext = resource.withRelationship(fr.relationships.goto.name,
    (rel) => () => loadPageContentLink(rel.link('related')),
    () => () => undefined);

  const maybeHandlePrevious = resource.withRelationship(fr.relationships.previousLink.name,
    (rel) => () => loadPageContentLink(rel.link('related')),
    () => () => undefined);

  return (
    <React.Fragment>
      <FDContentContainer maxWidth="md">
        <FDStack direction="column" alignItems="center" spacing={6} paddingY={2}>
          <FDStack direction={'column'} alignItems={'center'} spacing={2}>
            <MetaControlField attr={'taxYearHeader'} />
            <TaxYearOptionsDropdown resource={resource} />
          </FDStack>
          <MetaControlField attr={'title'} {...dataAttrs('next-steps-title')} />
          <FDPaper appearance={'elevated'} padding={3}>
            <FDStack direction="column" alignItems="center" spacing={3}>
              {resource.withRelationship(fr.relationships.plannerProfileImage.name, (rel) => (
                <FDStack direction={'column'} alignItems={'center'} justifyContent={'center'} spacing={1}>
                  <FDAvatar alt={rel.meta('prompt') || ''} src={rel.link('related').url()} size={'lg'} />
                  <MetaControlField attr="sentByAgentName" />
                </FDStack>
              ),
              () => null)}
              <MetaControlField attr={'meetingDescription'} />
              {resource.withRelationship(fr.relationships.scheduleMeeting.name, (rel) => (
                <FDPrimaryActionButton
                  icon={rel.meta('icon')}
                  label={rel.meta('prompt')}
                  onClick={() => {
                    navigateTo(
                      dashboardWithModal('clientSchedulerModal', {
                        link: rel.link('related').url(),
                      }),
                    );
                  }}
                  {...dataAttrs('schedule-meeting')}
                />
              ), () => null)}
              {resource.withRelationship(fr.relationships.scheduleChiliPiperMeeting.name, (rel) => (
                <FDPrimaryActionButton
                  icon={rel.meta('icon')}
                  label={rel.meta('prompt')}
                  href={rel.link('related').url()}
                  {...dataAttrs('schedule-chilipiper-meeting')}
                />
              ), () => null)}
              {resource.withRelationship(fr.relationships.messages.name, (rel) => (
                <FDPrimaryActionButton
                  icon={rel.meta('icon')}
                  label={rel.meta('prompt')}
                  onClick={() => loadPageContentLink(rel.link('related'))}
                  {...dataAttrs('message-my-planner')}
                />
              ), () => null)}
              {resource.withRelationship(fr.relationships.nextMeeting.name, (rel) => (
                <FDTextButton
                  icon={rel.meta('icon')}
                  iconPosition={'start'}
                  label={rel.meta('prompt')}
                  onClick={() => history.push(clientPaths.myMeetings)}
                />
              ), () => null)}
              <LightPaper padding={2}>
                <MetaControlField attr="description" />
              </LightPaper>
            </FDStack>
          </FDPaper>
          <FDBox paddingY={4} />
        </FDStack>
      </FDContentContainer>
      <StepNavigationFooter
        onNext={handleNext}
        onPrevious={maybeHandlePrevious}
        label={resource.attr('primaryActionText')}
      />
    </React.Fragment>
  );
};

Layout.defaultProps = {
};

Layout.propTypes = {
};

export default Layout;
